import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import RequiresAuth from 'components/auth/RequiresAuth';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import AssetThumbnail from 'components/common/AssetThumbnail';
import CardForm from 'components/order/CardForm';
/* import PaypalForm from 'components/order/PaypalForm'; */
import SavedPaymentInfo from 'components/order/SavedPaymentInfo';
import Summary from 'components/order/Summary';
import InteractionOverlay from 'components/order/InteractionOverlay';
import { asyncFetchBundle } from 'actions/bundles';
import { asyncFetchTemplate } from 'actions/templates';
import * as orderActions from 'actions/order';
import { slugify } from 'util/seo';
import ReCAPTCHA from 'react-google-recaptcha';

import classNames from 'classnames';
import * as Const from 'util/constants';
import './Order.scss';

export class Order extends Component {
  componentDidMount() {
    const { type } = this.props.match.params;
    const { reset, checkCaptcha } = this.props;
    reset();
    checkCaptcha(); // clear previous captcha validations
    if (type === Const.TYPE_TEMPLATES) this.loadTemplate();
    else this.loadBundle();
  }

  loadBundle() {
    const { id, type } = this.props.match.params;
    const { bundle, fetchBundle } = this.props;
    if (!bundle || bundle.id !== parseInt(id)) {
      fetchBundle(id);
    }
    if (bundle) {
      if (type === Const.TYPE_IMAGE_BUNDLES) document.title = `Doodly: ${bundle.name} SVG doodle images`;
      else document.title = `Doodly: ${bundle.name}`;
    }
  }

  loadTemplate() {
    const { id } = this.props.match.params;
    const { template, fetchTemplate } = this.props;
    if (!template || template.id !== parseInt(id)) {
      fetchTemplate(id);
    }
    if (template) {
      document.title = `Doodly: ${template.title} template`;
    }
  }

  handlePaymentMethodChange = (event, method) => {
    event.preventDefault();
    this.props.changePaymentMethod(method);
  };

  handleToogleSavedInfo = event => {
    event.preventDefault();
    this.props.toggleSavedPaymentInfo();
  };

  handlePaymentMethodTokenization = paymentInfo => {
    const { type } = this.props.match.params;
    const { bundle, purchaseBundle, template, purchaseTemplate } = this.props;
    if (type === Const.TYPE_TEMPLATES) purchaseTemplate(template.id, paymentInfo);
    else purchaseBundle(bundle.id, paymentInfo);
  };

  purchaseUsingSavedPaymentInfo = () => {
    const { type } = this.props.match.params;
    const { bundle, purchaseBundle, template, purchaseTemplate, captchaSuccessful } = this.props;
    if (!captchaSuccessful) {
      alert('Please complete the captcha challenge in order to continue.');
      return;
    }
    if (type === Const.TYPE_TEMPLATES) purchaseTemplate(template.id);
    else purchaseBundle(bundle.id);
  };

  render() {
    const { id, type } = this.props.match.params;
    const {
      bundle,
      template,
      savedPaymentInfo,
      purchaseSuccessful,
      useSavedPaymentInfo,
      isProcessing,
      useCreditCard,
      reset,
      checkCaptcha
    } = this.props;
    const dataLoaded =
      type === Const.TYPE_TEMPLATES ? template && template.id === parseInt(id) : bundle && bundle.id === parseInt(id);
    // const category = bundle ? categories.find(c => c.id === parseInt(bundle.categ_id)) : null;
    let linkTypeStr;
    switch (type) {
      case Const.TYPE_IMAGE_BUNDLES:
        linkTypeStr = 'Images';
        break;
      case Const.TYPE_AUDIO_BUNDLES:
        linkTypeStr = 'Audios';
        break;
      case Const.TYPE_TEMPLATES:
        linkTypeStr = 'Templates';
        break;
      default:
    }
    const title = type === Const.TYPE_TEMPLATES ? template && template.title : bundle && bundle.name;
    const thumbPath = type === Const.TYPE_TEMPLATES ? template && template.thumb_path : bundle && bundle.thumb_path;
    const description = type === Const.TYPE_TEMPLATES ? template && template.description : bundle && bundle.description;

    if (purchaseSuccessful) {
      reset();
      return <Redirect to={`/my-purchases/${type}`} />;
    }

    return (
      <div className="order">
        <RequiresAuth />
        <Header className={type} />
        <Content className={type}>
          {dataLoaded && (
            <div className="breadcrumbs">
              <Link to="/">Home</Link>
              <span className="sep">&gt;</span>
              <Link to={`/${type}`}>{linkTypeStr}</Link>
              <span className="sep">&gt;</span>
              <Link to={`/${type.slice(0, -1)}/${id}/${slugify(title)}`}>{title}</Link>
            </div>
          )}

          <div className="sheet">
            {dataLoaded ? (
              <div className="row">
                <div className="col-md-5 info">
                  <AssetThumbnail className="large thumb" image={thumbPath} style={{ backgroundSize: 'cover' }} />
                  <h2>{title}</h2>
                  <div className="description">
                    {description.split('\n').map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="payment-info">
                    <h3>Payment Information</h3>
                    {useSavedPaymentInfo ? (
                      <>
                        {savedPaymentInfo && (
                          <div className="payment-option saved p-4">
                            <SavedPaymentInfo {...savedPaymentInfo} />
                            <hr />
                            <a href="/" onClick={event => this.handleToogleSavedInfo(event)}>
                              Use different payment information
                            </a>
                            <Summary bundleType={type} className="mt-4" />
                            <div className="d-flex justify-content-between mt-4">
                              <ReCAPTCHA
                                sitekey="6LeOVrEUAAAAACN_W6Jz43aRUH0eraIqB35XnYAK"
                                onChange={token => checkCaptcha(token)}
                              />
                              <button className="btn btn-green" onClick={() => this.purchaseUsingSavedPaymentInfo()}>
                                {isProcessing ? 'Processing...' : 'Buy Now'}
                              </button>
                            </div>
                            <InteractionOverlay active={isProcessing} />
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="new">
                        {savedPaymentInfo && (
                          <>
                            <a href="/" onClick={event => this.handleToogleSavedInfo(event)}>
                              Use saved payment information
                            </a>
                            <hr />
                          </>
                        )}
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              href="/"
                              className={classNames('btn-link nav-link', { active: useCreditCard })}
                              onClick={event => this.handlePaymentMethodChange(event, 'credit_card')}
                            >
                              Credit Card
                            </a>
                          </li>
                          {/* <li className="nav-item">
                            <button
                              href="/"
                              className={classNames('btn-link nav-link', { active: usePaypal })}
                              onClick={event => this.handlePaymentMethodChange(event, 'paypal')}
                            >
                              Paypal
                            </button>
                          </li> */}
                        </ul>
                        {useCreditCard && (
                          <CardForm
                            bundleType={type}
                            onTokenization={data => this.handlePaymentMethodTokenization(data)}
                          />
                        )}
                        {/* {usePaypal && (
                          <PaypalForm
                            bundleType={type}
                            onTokenization={data => this.handlePaymentMethodTokenization(data)}
                          />
                        )} */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              'Loading...'
            )}
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user, bundles, templates, order, categories } = state;
  const { useSavedPaymentInfo, isProcessing, useCreditCard, purchaseSuccessful, captchaSuccessful } = order;
  return {
    bundle: bundles.currentBundle,
    template: templates.currentTemplate,
    savedPaymentInfo: user.paymentInfo,
    useSavedPaymentInfo,
    isProcessing,
    useCreditCard,
    purchaseSuccessful,
    categories,
    captchaSuccessful
  };
};

const mapDispatchToProps = dispatch => ({
  changePaymentMethod: method => dispatch(orderActions.changePaymentMethod(method)),
  toggleSavedPaymentInfo: () => dispatch(orderActions.toggleSavedPaymentInfo()),
  fetchBundle: bundleId => dispatch(asyncFetchBundle(bundleId)),
  fetchTemplate: templateId => dispatch(asyncFetchTemplate(templateId)),
  purchaseBundle: (bundleId, paymentInfo) => dispatch(orderActions.asyncOrderBundle(bundleId, paymentInfo)),
  purchaseTemplate: (templateId, paymentInfo) => dispatch(orderActions.asyncOrderTemplate(templateId, paymentInfo)),
  reset: () => dispatch(orderActions.reset()),
  checkCaptcha: token => dispatch(orderActions.asyncCheckCaptcha(token))
});

export default connect(mapStateToProps, mapDispatchToProps)(Order);
